import type {IdentityCardData} from './IdentityCardData';

export type IdentityCard = {
  id: string;
  identityCardData: IdentityCardData;
};
